import { StringJsonLexervr9dj3kex5li as StringJsonLexer } from './StringJsonLexer.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { charToTokenClass1wja4xge82waq as charToTokenClass } from './AbstractJsonLexer.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerWithCommentsClass;
function StringJsonLexerWithComments() {
  if (StringJsonLexerWithCommentsClass === VOID) {
    class $ extends StringJsonLexer() {
      f2t() {
        var source = this.q2w();
        var cpos = this.t2w();
        if (cpos >= source.length || cpos === -1)
          return 10;
        this.s2m_1 = cpos + 1 | 0;
        return charToTokenClass(charCodeAt(source, cpos));
      }
      b2t() {
        var current = this.t2w();
        if (current >= this.q2w().length || current === -1)
          return false;
        return this.u2w(charCodeAt(this.q2w(), current));
      }
      m2t(expected) {
        var source = this.q2w();
        var current = this.t2w();
        if (current >= source.length || current === -1) {
          this.s2m_1 = -1;
          this.v2w(expected);
        }
        var c = charCodeAt(source, current);
        this.s2m_1 = current + 1 | 0;
        if (c === expected)
          return Unit_instance;
        else {
          this.v2w(expected);
        }
      }
      a2t() {
        var source = this.q2w();
        var cpos = this.t2w();
        if (cpos >= source.length || cpos === -1)
          return 10;
        this.s2m_1 = cpos;
        return charToTokenClass(charCodeAt(source, cpos));
      }
      t2w() {
        var current = this.s2m_1;
        if (current === -1)
          return current;
        var source = this.q2w();
        $l$loop_1: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop_1;
          }
          if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
            var tmp0_subject = charCodeAt(source, current + 1 | 0);
            if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
              current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
              if (current === -1) {
                current = source.length;
              } else {
                current = current + 1 | 0;
              }
              continue $l$loop_1;
            } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
              current = indexOf(source, '*/', current + 2 | 0);
              if (current === -1) {
                this.s2m_1 = source.length;
                this.o2r('Expected end of the block comment: "*/", but had EOF instead');
              } else {
                current = current + 2 | 0;
              }
              continue $l$loop_1;
            }
          }
          break $l$loop_1;
        }
        this.s2m_1 = current;
        return current;
      }
    }
    initMetadataForClass($, 'StringJsonLexerWithComments');
    StringJsonLexerWithCommentsClass = $;
  }
  return StringJsonLexerWithCommentsClass;
}
//region block: exports
export {
  StringJsonLexerWithComments as StringJsonLexerWithComments3bzrli3gl2cah,
};
//endregion

//# sourceMappingURL=CommentLexers.mjs.map
